import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterQty'
})
export class FilterQtyPipe implements PipeTransform {

  transform(arr: any, qty1: any, qty2: any): any {
    if ( qty1 == '' || qty1 == null || qty1 == undefined || qty1 == 'undefined' || arr == [] || arr == undefined || arr == null || qty2 == '' || qty2 == null || qty2 == undefined || qty2 == 'undefined') {
      return arr;
    } else{
      return arr.filter((arr: any) =>{
        return arr.qtyNoRepeate >= qty1 && arr.qtyNoRepeate <= qty2
      })
    }
  }

}
